import { type ReactNode, useRef } from "react";
import { type ButtonProps } from "@mui/material/Button";
import * as Styles from "./CustomButton.styles";

export interface CustomButtonProps extends ButtonProps {
  children: ReactNode;
  onFileChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: () => void;
  backgroundColor?: string;
  hoverBackgroundColor?: string;
  textColor?: string;
  hoverTextColor?: string;
}

export function CustomButton({
  children,
  onFileChange,
  endIcon,
  backgroundColor,
  hoverBackgroundColor,
  textColor,
  hoverTextColor,
  onClick,
  variant = "contained",
  ...props
}: CustomButtonProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  function handleClick() {
    if (onFileChange) {
      inputRef.current?.click();
    }
    onClick?.();
  }

  return (
    <>
      <Styles.CustomButton
        {...props}
        variant={variant}
        onClick={handleClick}
        endIcon={endIcon}
        backgroundColor={backgroundColor}
        hoverBackgroundColor={hoverBackgroundColor}
        textColor={textColor}
        hoverTextColor={hoverTextColor}
      >
        {children}
      </Styles.CustomButton>

      {onFileChange && (
        <Styles.FileInput
          ref={inputRef}
          type="file"
          accept=".xml"
          onChange={(event) => {
            onFileChange(event);
            event.target.value = "";
          }}
        />
      )}
    </>
  );
}
